const TextareaNot = ({ name, setValue, lable }) => {
    return (<>
        <div className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 xs:pt-1 lg:pt-1 flex justify-start items-center">
            <p className="xs:text-sm sm:text-base font-onestRegular text-secondary">{lable}</p>
        </div>
        <div className="xs:h-36 sm:h-40 lg:h-40">
            <textarea
                className="xs:px-6 xs:!mb-[2px] sm:mb-1 sm:px-6 lg:px-8 bg-[#171717] xs:text-sm sm:text-base font-onestRegular w-full py-4 h-full focus:outline-none text-[#808080] focus:bg-primary transition duration-300 delay-100 focus:ring-2 focus:ring-goldMetallic rounded-3xl"
                placeholder={'Type here'}
                onChange={(e) => setValue(name, e.target.value)}
            />
        </div>
    </>
    );
};

export default TextareaNot;
